export default __webpack_public_path__ + "static/media/banner_premiossume_movil.68dd244d.jpg";